import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'
const {
  endpoints: {
    company: { companies: url },
  },
} = config

const getUrl = (company) => url.replace(':idCompany', company._id || null)

/**
 * Add a new company to the company
 * @param {Object} company
 */
const add = (company) => axios.post(getUrl(null), { company }, { headers: getHeaders(true) })

/**
 * Get all companies or specific company.
 * @param {Object} company Company object
 */
const get = (company, params) => axios.get(getUrl(company), { headers: getHeaders(true), params })

/**
 * Udate company information.
 * @param {Object} company Company to update
 */
const update = (company) => axios.put(getUrl(company), { company }, { headers: getHeaders(true) })

/**
 * Delete a company.
 * @param {Object} company Company object to delete
 */
const deleteCompany = (company, downloadData = false) =>
  axios({
    method: 'delete',
    url: getUrl(company),
    headers: getHeaders(true),
    params: {
      downloadData,
    },
    responseType: downloadData ? 'arraybuffer' : 'json',
  })

export default { add, get, update, deleteCompany }
